import React from 'react'
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { Link } from 'react-router-dom';
import { FaFacebookF } from "react-icons/fa";
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import SvgFooter from '../resources/RinuFooter.svg';
import InstagramIcon from '@mui/icons-material/Instagram';
import SvgFooterLight from '../resources/RinuFooterLight.svg';
import { useTranslation } from '../hook/Translation';

export default function Footer({ dark }) {

    const { t } = useTranslation();

    const skin = [
        { name: 'EMFACE', link: 'skin/emface-facial-muscle-lift-tone' },
        { name: 'EMFUSION', link: 'skin/emfusion-trans-dermal-infusion-facial' },
        { name: 'EXION Fractional Microneedling RF', link: 'skin/rf-collagen-induction' },
        { name: 'EXION Clear RF', link: 'skin/exion-clear-rf' },
        { name: 'EXION Face', link: 'skin/exion-face-applicator' },
        { name: t('menu.hairRemoval'), link: 'skin/targeted-laser-skin-therapies' },/*Heqja e qimeve*/
        { name: t('menu.rosecave'), link: 'skin/clarity/clarity-ii-rosacea-treatment' },/*Trajtimi i Rosaceas*/
        { name: t('menu.pigmentation'), link: 'skin/clarity/clarity-ii-pigmentation-treatments' },/*Trajtimi i Pigmentimeve*/
        { name: t('menu.skinRegen'), link: 'skin/clarity/clarity-ii-laser-genesis–style-rejuvenation' },/*Rigjenerimi i Lëkurës*/
        { name: t('menu.nailFungus'), link: 'skin/clarity/clarity-ii-nail-fungus-treatment' },/*Trajtimi i Mykut të Thonjve*/
        { name: t('menu.vascularProblems'), link: 'skin/clarity/clarity-ii-vascular-treatments' },/*Trajtimi i Problemeve Vaskulare*/
        { name: 'FRACTIONAL CO₂ RESURFACING', link: 'skin/fractional-co2-resurfacing' },
        { name: 'ERBIUM GLASS SOFTLIFT', link: 'skin/hybrid-laser-erbium-glass' },
    ]

    const body = [
        { name: 'EMSCULPT Neo', link: 'body/emsculpt-neo-muscle-build-and-fat-reduction' },
        { name: 'EMTONE', link: 'body/emtone-cellulite-smoothing' },
        { name: 'EMSELLA', link: 'body/emsculpt-neo-muscle-build-and-fat-reduction-one' },
        { name: 'EMFEMME 360°', link: 'body/female-intimate-wellness-one' },
        { name: 'EXION Body', link: 'body/exion-rf-body-skin-tightening' },
  
    ]

    const messages = [
              { name: "RINU RITUAL", link: 'the-rinu-ritual' },
        { name: "St.Barth ChillOut ", link: 'elemental-alchemy' },
        { name: "Deep Tissue  ", link: 'still-stone-release' },
        { name: "Fytyrë dhe Dekolte", link: 'inner-sculpt' },
        { name: "Aroma Therapy", link: 'the-deep-rewire' },
        { name: "Cupping ", link: 'stretch-and-spirit' },
        { name: "Hot Stone", link: 'essence-of-two' },
    ]

    return (
        <Grid container component={'footer'} backgroundColor={dark ? '#21333B' : '#E9DFD5'} paddingBottom={{ md: '158px', xs: '50px' }} paddingX={'20px'} gap={{ md: '96px', xs: '50px' }}>
            <Grid size={12} width={'95%'} marginX={'auto'} marginTop={{ md: '80px', xs: '50px' }}>
                <Box>
                    <Box component={'img'} src={dark ? SvgFooterLight : SvgFooter} width={'100%'} height={{ md: '370px', xs: 'auto' }} />
                </Box>
            </Grid>
            <Grid size={12} marginX={'auto'} width={'95%'}>
                <Grid container spacing={4}>
                    <Grid size={{ lg: 2, xs: 12 }}>
                        <Typography  className={dark ? "lightLinkColor" : "darkLinkColor"} variant="body1" fontWeight={'600'} fontFamily={'DanmarkURW'}>SKIN</Typography>
                        <Box display={'flex'} flexDirection={'column'} gap={'2px'} marginTop={'10px'}>
                            {
                                skin.map((data, index) => (
                                    <Typography key={index} className={dark ? "lightLinkColor" : "darkLinkColor"} component={Link} to={data.link} width={'max-content'}>{data.name}</Typography>
                                ))
                            }
                        </Box>
                    </Grid>

                    <Grid size={{ lg: 2, xs: 12 }}>
                        <Typography className={dark ? "lightLinkColor" : "darkLinkColor"} variant="body1" fontWeight={'600'} fontFamily={'DanmarkURW'}>BODY</Typography>
                        <Box display={'flex'} flexDirection={'column'} gap={'2px'} marginTop={'10px'}>
                            {
                                body.map((data, index) => (
                                    <Typography key={index} className={dark ? "lightLinkColor" : "darkLinkColor"} component={Link} to={data.link} width={'max-content'}>{data.name}</Typography>
                                ))
                            }
                        </Box>
                    </Grid>

                    <Grid size={{ lg: 2, xs: 12 }}>
                        <Typography className={dark ? "lightLinkColor" : "darkLinkColor"} variant="body1" fontWeight={'600'} fontFamily={'DanmarkURW'}>MIND</Typography>
                        <Box display={'flex'} flexDirection={'column'} gap={'2px'} marginTop={'10px'}>
                            <Typography className={dark ? "lightLinkColor" : "darkLinkColor"} component={Link} to={'/mind/exomind'} width={'max-content'}>Exomind</Typography>
                        </Box>
                    </Grid>
                     <Grid size={{ lg: 2, xs: 12 }}>
                        <Typography  className={dark ? "lightLinkColor" : "darkLinkColor"} variant="body1" fontWeight={'600'} fontFamily={'DanmarkURW'}>MASAZHET</Typography>
                        <Box display={'flex'} flexDirection={'column'} gap={'2px'} marginTop={'10px'}>
                            {
                                messages.map((data, index) => (
                                    <Typography key={index} className={dark ? "lightLinkColor" : "darkLinkColor"} component={Link} to={data.link} width={'max-content'}>{data.name}</Typography>
                                ))
                            }
                        </Box>
                    </Grid>

                    <Grid size={{ lg: 1, xs: 12 }}>
                        <Typography className={dark ? "lightLinkColor" : "darkLinkColor"} variant="body1" fontWeight={'600'} fontFamily={'DanmarkURW'}>LINKS</Typography>
                        <Box display={'flex'} flexDirection={'column'} gap={'2px'} marginTop={'10px'}>
                            <Typography className={dark ? "lightLinkColor" : "darkLinkColor"} component={Link} to={'./blogs'} width={'max-content'}>Blogs</Typography>
                            <Typography className={dark ? "lightLinkColor" : "darkLinkColor"} component={Link} to={'./contact'} width={'max-content'}>About</Typography>
                            {/* <Typography className={dark ? "lightLinkColor" : "darkLinkColor"} component={Link} width={'max-content'}>Learn</Typography> */}
                            {/* <Typography className={dark ? "lightLinkColor" : "darkLinkColor"} component={Link} width={'max-content'}>Rinu+</Typography> */}
                            {/* <Typography className={dark ? "lightLinkColor" : "darkLinkColor"} component={Link} width={'max-content'}>Account</Typography> */}
                            {/* <Typography className={dark ? "lightLinkColor" : "darkLinkColor"} component={Link} width={'max-content'}>Shop</Typography> */}
                            {/* <Typography className={dark ? "lightLinkColor" : "darkLinkColor"} component={Link} width={'max-content'}>Faq</Typography> */}
                        </Box>
                    </Grid>

                    <Grid size={{ lg: 3, xs: 12 }}>
                        <Grid container spacing={2}>
                            <Grid size={12}>
                                <Typography className={dark ? "lightLinkColor" : "darkLinkColor"} variant="body1">{t('homepage.join_us')}</Typography>
                            </Grid>
                            <Grid size={12}>
                                <Box sx={{ '.MuiInputBase-formControl': { borderRadius: '40px', color: dark ? '#fff' : '#000' }, input: { paddingLeft: '25px' }, '.MuiOutlinedInput-notchedOutline': { borderColor: dark ? '#fff' : '#000' } }}>
                                    <TextField fullWidth placeholder='Email Address' />
                                </Box>
                            </Grid>
                            <Grid size={12}>
                                <Box display={'flex'} alignItems={'center'} sx={{ svg: { fill: dark ? '#fff' : '#000' } }}>
                                    <Checkbox disableFocusRipple disableRipple disableTouchRipple sx={{ paddingLeft: 0 }} />
                                    <Typography variant="body2" className={dark ? "lightLinkColor" : "darkLinkColor"} sx={{ a: { color: 'text.secondary' } }}>{t('terms1')} <Box component={Link} sx={{ color: 'blue!important' }} to="./policy">{t('terms2')}</Box> {t('terms3')}</Typography>
                                </Box>
                            </Grid>
                            <Grid size={12}>
                                <Box display={'flex'} gap={'5px'}>
                                    <Box component={Link} target='_blank' to="https://www.facebook.com/profile.php?id=61576712822656" sx={{ svg: { fill: dark ? '#21333B' : '#E9DFD5' }, backgroundColor: dark ? '#FFF' : '#000', borderRadius: '100%', height: '30px', width: '30px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <FaFacebookF />
                                    </Box>
                                    <Box component={Link} target='_blank' to="https://www.instagram.com/rinu.medspa/" sx={{ svg: { fill: dark ? '#21333B' : '#E9DFD5' }, backgroundColor: dark ? '#FFF' : '#000', borderRadius: '100%', height: '30px', width: '30px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <InstagramIcon />
                                    </Box>
                                    {/* <Box component={Link} target='_blank' to="https://www.instagram.com/rinu.medspa/" sx={{svg: {fill: dark ? '#21333B' : '#E9DFD5'}, backgroundColor: dark ? '#FFF' : '#000', borderRadius: '100%', height: '30px', width: '30px', display: 'flex', justifyContent: 'center', alignItems: 'center'}} >
                                        <YouTubeIcon />
                                    </Box> */}
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
};